import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import CustomCursor from "@/components/CustomCursor";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import AIReshaping from "@/components/AIReshaping";
import { WhatWeBuild, GrowthSystem, Services, Industries } from "@/components/MidSections";
import { WhyUs, HowItWorks, AssessmentCTA, CaseStudies } from "@/components/LowerSections";
import { FinalContact, Footer } from "@/components/ContactFooter";
import ChatWidget from "@/components/ChatWidget";
import PaymentResult from "@/components/PaymentResult";
import { initCal } from "@/lib/cal";

function App() {
  const isPayment = typeof window !== "undefined" && window.location.pathname.startsWith("/payment/");

  useEffect(() => { initCal(); }, []);

  useEffect(() => {
    if (isPayment) return;
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true, lerp: 0.1 });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); window.__lenis = null; };
  }, [isPayment]);

  if (isPayment) return <PaymentResult />;

  return (
    <div className="App grain" data-testid="app-root">
      <CustomCursor />
      <Toaster position="bottom-right" theme="dark" richColors />
      <Navbar />
      <main>
        <Hero />
        <AIReshaping />
        <WhatWeBuild />
        <GrowthSystem />
        <Services />
        <Industries />
        <WhyUs />
        <HowItWorks />
        <AssessmentCTA />
        <CaseStudies />
        <FinalContact />
      </main>
      <Footer />
      <ChatWidget />
    </div>
  );
}

export default App;
